import React, { useEffect, useState } from "react";
import FilterDropdown from "../../components/common/FilterDropdown";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  getAllMeditationData,
  getMeditationDataById,
  uploadMeditationData,
  deleteMeditationDataById,
  updateStatusMeditation
} from "../../api/meditation/uploadMeditation";
import AddMotivatonalManagerButton from "./components/AddMotivatonalManagerButton";
import MotivatonalManagerTable from "./components/MotivatonalManagerTable";
const RecipeMotivationalManager = () => {
  useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [error, setError] = useState(null);
  const [uploadedJson, setUploadedJson] = useState(null);
  const [planData, setPlanData] = useState({});
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [currentModal, setCurrentModal] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const openModal = (modalNumber) => {
    setCurrentModal(modalNumber);
  };
  const fetchPlans = async () => {
    try {
      const data = await getAllMeditationData();
      setPlans(data?.recipes);
    } catch (error) {
      setError("Failed to fetch plans");
      console.error(error);
    }
  };
  useEffect(() => {

    fetchPlans().then();
  }, []);

  const convertTimestamp = (createdAtSeconds) => {
    const uploadDate = new Date(createdAtSeconds * 1000);
    return uploadDate.toLocaleDateString();
  };

  const tableHeader = [
    { label: "Sr. No", width: "5%" },
    { label: "Workout Details", width: "30%" },
    { label: "Uploaded on", width: "25%" },
    { label: "Status", width: "15%" },
    { label: "Edit", width: "5%" },
    { label: "Action", width: "5%" },
    { label: "Download", width: "5%" },

  ];
  const handleEditClick = async (planId) => {

    setSelectedPlanId(planId);

    try {
      const data = await getMeditationDataById(planId);
      setUploadedJson(data);
      setPlanData(data);
      openModal(2);
    } catch (error) {
      setError(error.message);
      console.error("Failed to load plan:", error.message);
    }
  };
  const showToast = (message, success) => {
    if (success) {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };
  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeLimit = 50 * 1024 * 1024;
      if (selectedFile.size > fileSizeLimit) {
        setErrorMessage(
          "File size exceeds the 50MB limit. Please upload a smaller file."
        );
        setFileName(null);
        return;
      }

      const validExtensions = ["json"];
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrorMessage("Please upload a valid JSON file.");
        setFileName(null);
        return;
      }

      setErrorMessage(null);
      setFileName(selectedFile.name);
      setFile(selectedFile);

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const jsonData = JSON.parse(reader.result);
          setUploadedJson(jsonData);
          setPlanData(jsonData);
        } catch (e) {
          setErrorMessage("The uploaded file is not a valid JSON file.");
          setFile(null);
        }
      };
      reader.readAsText(selectedFile);
    }
  };

  const handleSubmit = async (formData) => {
    if (!file) {
      showToast("No file selected for upload.");
      return;
    }

    if (formData.cover_image_url) {
      uploadedJson.meditation_session.cover_image_url = formData.cover_image_url;
    }

    const updatedFile = new Blob([JSON.stringify(uploadedJson)], { type: 'application/json' });
    const updatedFileName = fileName;

    const formDataToUpload = new FormData();
    formDataToUpload.append("file", updatedFile, updatedFileName);

    try {
      const response = await uploadMeditationData(formDataToUpload, updatedFileName);
      if (response && response.fileUrl) {
        showToast(
          `Success! Your workout plan has been saved. Refer to the dashboard for details.`,
          true
        );
        setFile(null);
        setFileName(null);
        setUploadedJson(null);
        setPlanData({});
        // Navigate("/add-recipe-motivation");

        window.location.assign("/add-recipe-motivation");
      }
    } catch (error) {
      showToast("Failed to upload plan.");
    }
  };


  const toggleStatus = async (plan) => {

    const response = await updateStatusMeditation(plan?.id);
    if (response) {
      showToast(
        `Success! Your recipe plan Status saved.`,
        true
      );
      setFile(null);
      setFileName(null);
      setUploadedJson(null);
      setPlanData({});
      await fetchPlans()
    }
  };


  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Motivational?")) {
      try {
        const response = await deleteMeditationDataById(id);
        if (response.message) {
          toast.success("single Motivational deleted successfully!");
          await fetchPlans();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        toast.error("Failed to delete single Motivational file.");
        console.error("Error deleting Motivational:", error);
      }
    }
  }


  const handleAddNewPlanClick = () => {
    setSelectedPlanId(null);
  };

  const modalHeading = "Motivational Manage";
  const modalAddBtn = "Add New Recipe";

  // Pagination Logic
  const totalPages = Math.ceil(plans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedPlans = plans.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <h2>{modalHeading}</h2>
          </div>
          <div className="col-sm-6">
            <div className="btn-sec">
              <FilterDropdown />
              <AddMotivatonalManagerButton
                setCurrentModal={setCurrentModal}
                currentModal={currentModal}
                openModal={openModal}
                modalAddBtn={modalAddBtn}
                selectedPlanId={selectedPlanId}
                handleFileUpload={handleFileUpload}
                handleSubmit={handleSubmit}
                uploadedJson={uploadedJson}
                planData={planData}
                errorMessage={errorMessage}
                fileName={fileName}
                onAddNewPlanClick={handleAddNewPlanClick}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <MotivatonalManagerTable
            header={tableHeader}
            plans={paginatedPlans}
            error={error}
            convertTimestamp={convertTimestamp}
            onEditClick={handleEditClick}
            handleDelete={handleDelete}
            toggleStatus={toggleStatus}
          />
          {/* Pagination */}
          {totalPages >= 1 && (
            <nav className="mt-3">
              <ul className="pagination justify-content-center">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                    &laquo;
                  </button>
                </li>

                {/* Page Numbers */}
                {[...Array(totalPages)].map((_, i) => {
                  const pageNumber = i + 1;
                  return (
                    (pageNumber <= 2 || pageNumber >= totalPages - 1 || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) && (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                          {pageNumber}
                        </button>
                      </li>
                    )
                  );
                })}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecipeMotivationalManager;
